"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import PencilIcon, { PencilIconSize } from "@/components/utils/icons/PencilIcon";
import CommonAnimationWrapper from "@/components/utils/animation/CommonAnimationWrapper";
import CommonAnimationOpacity from "@/components/utils/animation/CommonAnimationOpacity";
import WaveHeaderPictureEditModal from "./WaveHeaderPictureEditModal";
export default function WaveHeaderPictureEdit(t0) {
  const $ = _c(7);
  const {
    wave
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = e => {
      e.stopPropagation();
      setIsOpen(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <button type="button" onClick={t1} aria-label="Edit wave picture" className="tw-absolute tw-inset-0 tw-hidden tw-items-center tw-justify-center tw-rounded-full tw-bg-black/45 tw-text-iron-100 tw-transition tw-duration-200 tw-ease-out focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-primary-500 focus:tw-ring-offset-2 focus:tw-ring-offset-iron-900 desktop-hover:group-hover:tw-flex"><PencilIcon size={PencilIconSize.SMALL} /></button>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== isOpen || $[3] !== wave) {
    t3 = isOpen && <CommonAnimationOpacity key="picture-modal" elementClasses="tw-absolute tw-z-50" elementRole="dialog" onClicked={_temp}><WaveHeaderPictureEditModal key={wave.id} wave={wave} onClose={() => setIsOpen(false)} /></CommonAnimationOpacity>;
    $[2] = isOpen;
    $[3] = wave;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <>{t2}<CommonAnimationWrapper mode="sync" initial={true}>{t3}</CommonAnimationWrapper></>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}
function _temp(e_0) {
  return e_0.stopPropagation();
}